import React from "react";
import { Helmet } from "react-helmet-async";
import CodeEmbedLoadable from "../../pages/loadables/code-embed";

function Code({ hideNavigation }) {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Share Code - Poper`}</title>
      </Helmet>
      <div className="w-full min-h-full pt-[72px]">
        <CodeEmbedLoadable className={"mx-auto"} />
      </div>
    </>
  );
}

export default Code;
